import { Briefcase, Building, Calendar } from 'lucide-react'

export default function ProfileSidebar() {
    return (
        <div className="w-[332px] bg-black text-white flex flex-col h-screen fixed left-0">
            <div className="flex flex-col items-center">
                <div className="bg-gray-200 w-full h-[90px]"></div>
                <div className="relative -mt-12 mb-4">
                    <div className="rounded-full border-4 border-black overflow-hidden bg-white w-24 h-24 flex items-center justify-center">
                        <img
                            src="/placeholder.svg?height=96&width=96"
                            alt="Profile picture"
                            width={96}
                            height={96}
                            className="object-cover"
                        />
                    </div>
                </div>
                <h2 className="font-medium text-lg">Arun Prasath M</h2>
                <div className="flex items-center gap-1 mt-1 mb-4">
                    <div className="w-4 h-4 bg-white"></div>
                </div>
            </div>

            <div className="px-4 text-sm text-gray-300 space-y-2">
                <div className="flex items-center gap-2">
                    <Calendar className="w-4 h-4 opacity-70" />
                    <span>Class of 2026</span>
                </div>
                <div className="flex items-center gap-2">
                    <Briefcase className="w-4 h-4 opacity-70" />
                    <span>B.Tech in Computer Science Engineering</span>
                </div>
                <div className="flex items-center gap-2">
                    <Building className="w-4 h-4 opacity-70" />
                    <span>
                        Vels Institute of Science, Technology & Advanced Studies
                        (VISTAS), Chennai
                    </span>
                </div>
            </div>

            <div className="px-4 mt-6 text-sm text-gray-300">
                <h3 className="font-medium mb-2 text-center">About Me</h3>
                <p className="leading-relaxed">
                    Passionate about coding, problem- solving, and exploring
                    tech innovations. Skilled in Python, Java, and C++, with
                    interests in software development, AI, and web development.
                </p>
            </div>

            <div className="mt-auto mb-6 p-4">
                <div className="flex justify-center gap-4 mt-4">
                    <div className="bg-gray-700 rounded-full p-2">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                            <rect x="2" y="9" width="4" height="12"></rect>
                            <circle cx="4" cy="4" r="2"></circle>
                        </svg>
                    </div>
                    <div className="bg-gray-700 rounded-full p-2">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <circle cx="12" cy="12" r="10"></circle>
                            <circle cx="12" cy="12" r="4"></circle>
                        </svg>
                    </div>
                    <div className="bg-gray-700 rounded-full p-2">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <circle cx="12" cy="12" r="10"></circle>
                            <path d="M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"></path>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    )
}
